import type { ReactNode } from "react";
import { useReducedMotion } from "motion/react";
import { AnimateUIProvider } from "@/components/animate-ui";
import { Toaster, type ToasterPlacement } from "@/components/ui/toast";

// Animate UI scales its own timings (a select's value swap among them) by this tempo and
// ignores the reduced-motion setting there, so a person who asks for less motion gets
// them near instant. Not zero: a spring's stiffness is divided by it.
const STILL = 0.01;

export function UiProvider({
  children,
  theme = "light",
  toaster,
}: {
  children: ReactNode;
  theme?: "light" | "dark";
  toaster?: ToasterPlacement;
}) {
  const reduce = useReducedMotion();
  return (
    <AnimateUIProvider tempo={reduce ? STILL : undefined}>
      {children}
      <Toaster theme={theme} {...toaster} />
    </AnimateUIProvider>
  );
}
